import { render } from 'preact';
import { config } from 'utils/config';
import logger from 'utils/logger';
import { ConfigProvider } from './context/ConfigContext';
import Lookup from 'components/Lookup/Lookup';

const LOOKUP_WIDGET_MOUNT_ELEMENT_ID = 'll-product-lookup';

logger.info('Script Config:', config);

const mountElement = document.getElementById(LOOKUP_WIDGET_MOUNT_ELEMENT_ID);

const renderIn = document.createElement('div');

// Move inline styles from mount element to lookup widget
const parentStyle = mountElement.getAttribute('style');

// In case page style is messing with the mount element display
// mountElement.style.display = 'block';
mountElement.setAttribute('style', 'display: block');

// This shadow DOM was created by the vite-plugin-css-injected-by-js plugin
// configured in vite-lookup.config.js
mountElement.shadowRoot.appendChild(renderIn);

const App = () => {
  return (
    <ConfigProvider>
      <Lookup style={parentStyle} />
    </ConfigProvider>
  );
};

if (!mountElement) {
  logger.error('Missing mount element with ID:', LOOKUP_WIDGET_MOUNT_ELEMENT_ID);
} else {
  logger.info('Rendering to:', mountElement);
  render(<App />, renderIn);
}
